import { QueryFunctionContext, useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import { stringifyQuery } from 'utils/query';

export interface ICalendarViewSearchQuery {
  schedule_status: 'all' | 'draft' | 'published' | 'repeating';
  search_schedule_by_employee_id?: string;
  search_schedule_by_job_id?: string;
  search_schedule_by_date_range?: string;
}

export const fetchCalendarView = (searchQuery: ICalendarViewSearchQuery, signal: any) => {
  const stringifiedQuery = stringifyQuery(searchQuery);
  const newEndpoints = endpoints.scheduling.calendarView + '?' + stringifiedQuery;
  return http().get(newEndpoints, { signal });
};

export function useFetchCalendarView(searchQuery: ICalendarViewSearchQuery, options: any): UseQueryResult<any> {
  return useQuery({
    queryKey: ['fetchCalendarView', searchQuery],
    queryFn: ({ signal }: QueryFunctionContext) => fetchCalendarView(searchQuery, signal),
    ...options,
  });
}
